import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon19: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#73C177"
        d="M8.476 0c.133 0 .26.053.354.146l5.016 5.016a.504.504 0 0 1 .146.354L14 19.5a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5V.5A.5.5 0 0 1 .5 0h7.976Zm-.207 1H1v18h12l-.008-13.277L8.269 1ZM6.5 6.763a.5.5 0 0 1 .5.5v.819c.352.057.702.159 1.046.293.331.129.586.26.739.352a.5.5 0 0 1-.517.856 4.036 4.036 0 0 0-.585-.276c-.45-.176-.906-.28-1.335-.28-.888 0-1.507.425-1.507.974 0 .609.478.959 1.93 1.535l.142.056c1.765.698 2.42 1.162 2.42 2.259 0 1.205-.912 1.924-2.332 2.062L7 16.715a.5.5 0 0 1-1 0l-.001-.798a4.176 4.176 0 0 1-1.457-.383c-.332-.159-.557-.328-.681-.457a.5.5 0 1 1 .719-.695c.046.048.176.146.396.251.392.189.888.305 1.499.305 1.233 0 1.858-.405 1.858-1.087 0-.488-.43-.792-1.788-1.33l-.142-.056c-1.842-.729-2.562-1.256-2.562-2.464 0-1.096.944-1.838 2.158-1.957L6 7.263a.5.5 0 0 1 .5-.5ZM8.498 0A.5.5 0 0 1 9 .498l.022 4.504 4.48.014a.5.5 0 1 1-.004 1L8.522 6a.5.5 0 0 1-.498-.498L8 .502A.5.5 0 0 1 8.498 0Z"
      />
    </Svg>
  )
}
